import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import TrustBar from '../components/TrustBar';
import BenchesSection from '../components/BenchesSection';
import ServicesSection from '../components/ServicesSection';
import HowItWorks from '../components/HowItWorks';
import BrandsSection from '../components/BrandsSection';
import AboutSection from '../components/AboutSection';
import ReviewsSection from '../components/ReviewsSection';
import FaqSection from '../components/FaqSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';

const HomePage = () => (
  <div className="min-h-screen bg-[#0a0a0a]">
    <Header />
    <HeroSection />
    <TrustBar />
    <BenchesSection />
    <ServicesSection />
    <HowItWorks />
    <BrandsSection />
    <AboutSection />
    <ReviewsSection />
    <FaqSection />
    <ContactSection />
    <Footer />
    <WhatsAppButton />
  </div>
);

export default HomePage;
